import {
  Accordion as MantineAccordion,
  AccordionChevron as MantineAccordionChevron,
  AccordionChevronProps as MantineAccordionChevronProps,
  AccordionControl as MantineAccordionControl,
  AccordionControlProps as MantineAccordionControlProps,
  AccordionItem as MantineAccordionItem,
  AccordionItemProps as MantineAccordionItemProps,
  AccordionPanel as MantineAccordionPanel,
  AccordionPanelProps as MantineAccordionPanelProps,
  AccordionProps as MantineAccordionProps,
} from '@mantine/core';

export type AccordionProps = MantineAccordionProps;
export type AccordionItemProps = MantineAccordionItemProps;
export type AccordionPanelProps = MantineAccordionPanelProps;
export type AccordionControlProps = MantineAccordionControlProps;
export type AccordionChevronProps = MantineAccordionChevronProps;

export const Accordion = MantineAccordion;
Accordion.displayName = 'Accordion';

export const AccordionItem = MantineAccordionItem;
AccordionItem.displayName = 'AccordionItem';

export const AccordionPanel = MantineAccordionPanel;
AccordionPanel.displayName = 'AccordionPanel';

export const AccordionControl = MantineAccordionControl;
AccordionControl.displayName = 'AccordionControl';

export const AccordionChevron = MantineAccordionChevron;
AccordionChevron.displayName = 'AccordionChevron';

// Attach subcomponents to Accordion for compound component pattern
Accordion.Item = AccordionItem;
Accordion.Panel = AccordionPanel;
Accordion.Control = AccordionControl;
Accordion.Chevron = AccordionChevron;
